export default __webpack_public_path__ + "static/media/Geyser-Brochure-2023.ac932058.pdf";